<template>
    <div class="custom-modal-content">
      <div v-if="isInitial || isLoaded">
        <b-row>
          <b-col>
            <b-container class="label">Model name:<span class="important-label">*</span></b-container>

            <b-form-input
                v-model="$v.modelname.$model"
                placeholder="Name"
                class="modal-input"
                :state="validationUtils.validateState($v, 'modelname')"
            >
            </b-form-input>
            <b-form-invalid-feedback>
                This is a required field.
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row>
            <b-col>
                <!--UPLOAD-->
                <b-container class="m-0 p-0" v-if="isInitial">
                  <form enctype="multipart/form-data" novalidate>
                      <div class="dropbox">
                      <input type="file" :name="uploadFieldName" :disabled="isSaving" @change="fileInputChange($event.target)"
                          :accept="formats" class="input-file">
                          <p>
                            Drag your file here to begin<br> or upload a file from your computer
                          </p>
                      </div>
                  </form>
                </b-container>
                <!--LOADED-->
                <div class="modal-image-container m-0 ml-1 mt-3">
                  <b-row>
                    <b-col sm=0 cols=6>
                      <b-container ref="divshow"></b-container>
                  </b-col>
                  <b-col sm=0 cols=3 ></b-col>
                  <b-col sm=0 cols=3 align-self="end">
                    <b-button
                        class="float-right"
                        variant="primary"
                        @click="saveModel();"
                        :disabled="!isLoaded"
                    >
                        Upload model
                    </b-button>
                  </b-col>
                  </b-row>
                </div>
            </b-col>
        </b-row>
      </div>
      
      <!--SAVING-->
      <b-container v-if="isSaving">
          <b-progress :value="value" :max="max" show-progress animated></b-progress>
      </b-container>
      <!--SUCCESS-->
      <div v-if="isSuccess">
          <b-container class="custom-modal-message">Success!</b-container>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
          <b-container class="custom-modal-message">
            Upload failed. <a href="javascript:void(0)" @click="reset()">Try again?</a>
          </b-container>
          <pre>{{ uploadError }}</pre>
      </div>
    </div>
</template>

<script>
import ModelViewer from '@/services/webgl.service'
import { upload } from '@/services/api.service';
import { required } from 'vuelidate/lib/validators'
import * as validationUtils from "@/utils/validation-utils";

const STATUS_INITIAL = 0, STATUS_LOADED = 1, STATUS_SAVING = 2, STATUS_SUCCESS = 3, STATUS_FAILED = 4;

export default {
    name: 'UploadModel',
    props: {
      storageType: String,
      formats: String,
    },
    data() {
      return {
        uploadError: null,
        currentStatus: null,
        uploadFieldName: 'models',
        modelname: '',
        value: 0,
        max: 100,
        modelViewer: null,
        width: 300,
        height: 300,
        files: []
      }
    },
    computed: {
      validationUtils() {
        return validationUtils;
      },
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
      isLoaded() {
        return this.currentStatus === STATUS_LOADED;
      }
    },
    validations: {
      modelname: {
        required,
      },
    },
    methods: {
      reset() {
        this.currentStatus = STATUS_INITIAL;
        this.uploadError = null;
        this.$v.$reset();
      },
      onProgress(percent) {
            this.value = percent;
      },
      save(formData) {
        this.currentStatus = STATUS_SAVING;
        this.modelViewer = null;
        this.$AuthService.getAccessToken(function() {
          upload(formData, this.$AuthService.token.accessToken, this.onProgress)
            .then(() => {
              this.currentStatus = STATUS_SUCCESS;
              this.$emit("model-uploaded");
            })
            .catch(err => {
              this.uploadError = err.response;
              this.currentStatus = STATUS_FAILED;
            });
        }.bind(this))
      },
      fileInputChange(event) {
          this.files = event.files;
          this.fileLoad(this.files);
      },
      saveModel() {
        this.$v.$touch();

        if (this.$v.$anyError) {
          return;
        }

        let image = this.modelViewer.getImage();

        fetch(image)
          .then(res => res.blob())
          .then(function(blob) {this.uploadFiles(this.files, blob)}.bind(this))
      },
      uploadFiles(fileList, image) {
        let formData = new FormData();

        if (!fileList.length || !this.modelname.length || !this.modelViewer) {
          return;
        }

        formData.append(this.uploadFieldName, fileList[0], fileList[0].name);
        formData.append("name", this.modelname);
        formData.append("format", this.modelViewer.type);
        formData.append(this.uploadFieldName, image, "thumbnail.jpg");
        formData.append("size", JSON.stringify(this.modelViewer.getSize()))
        formData.append("center", JSON.stringify(this.modelViewer.getCenter()))
        formData.append("storageType", this.storageType);

        this.save(formData);
      },
      fileLoad(filePath) {
        this.currentStatus = STATUS_LOADED;
        this.modelViewer = new ModelViewer(this.width, this.height);
        var renderer = this.modelViewer.loadFile(window.URL.createObjectURL(filePath[0]), filePath[0].name)
        
        this.$nextTick(function() {
          var divmodal = this.$refs.divshow
          divmodal.appendChild(renderer);
        }.bind(this))
      }
    },
    mounted() {
      this.reset();
    },
  }
</script>
